import { date as commonDate } from '@finley-technologies/common';
import { Util } from '@finley-technologies/finley-types';

export const isSameDay = (d1: Date, d2: Date): boolean =>
  d1.getDate() === d2.getDate() &&
  d1.getMonth() === d2.getMonth() &&
  d1.getFullYear() === d2.getFullYear();

export const isSameMonth = (d1: Date, d2: Date): boolean =>
  d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();

/**
 * we show calender view for the current month.
 * this function returns start and end date which will
 * ensure that we get the data for the current month plus any
 * surrounding dates that may be visible in the calender view
 */
export const getMonthDateRange = (
  date: Date,
): {
  startDate: Util.FullDateStr;
  endDate: Util.FullDateStr;
} => {
  // create a span of 7 days before and after the current month
  const startDate = new Date(date.getFullYear(), date.getMonth(), -7);
  const endDate = new Date(date.getFullYear(), date.getMonth() + 1, 7);

  return {
    startDate: commonDate.dateToFullDateString(startDate),
    endDate: commonDate.dateToFullDateString(endDate),
  };
};
